import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, FormGroup, Modal, Button, FormControl, ControlLabel } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import LoaderInline from "../helpers/LoaderInline";
import InlineError from "../messages/InlineError";

class DayOffRequestModal extends Component {

	submit = (e) => {
		e.preventDefault();
		this.props.onSubmit();
	}

	render() {
		return (
			<React.Fragment>
				<Modal className="dayoff-request-modal" show={this.props.showRequestModal} onHide={this.props.handleCloseRequestModal}>
					<form onSubmit={this.submit}>
						<Modal.Header>
							<button type="button" className="close btn-close-modal" aria-hidden="true" onClick={this.props.handleCloseRequestModal}>&times;</button>
							<Modal.Title>Day Off Request</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							{this.props.errors.days_off_error &&
								<Row>
									<Col md={12}>
										<div className="alert alert-danger alert-dayoff">
											<span><strong>Day off limit has been reached for period {moment(this.props.errors.period_start).format("DD-MM-YYYY")} - {moment(this.props.errors.period_end).format("DD-MM-YYYY")}</strong></span><br />
											<span>Days off taken: {this.props.errors.days_off_taken || null} </span><br />
											<span>Days off requested: {this.props.errors.days_off_requested || null} </span><br />
											<span>Days off allowed to take: {this.props.errors.days_off_available || null}</span><br />
										</div>
									</Col>
								</Row>
							}
							<Row>
								<Col md={12}>
									<FormGroup validationState={this.props.errors.name && "error"}>
										<ControlLabel>Title</ControlLabel>
										<FormControl type="string" name="name" placeholder="Enter title" value={this.props.formData.name || ""} onChange={this.props.onChange} />
										{this.props.errors.name && <InlineError text={this.props.errors.name} />}
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col md={6}>
									<FormGroup validationState={this.props.errors.start && "error"} className="datepicker-100">
										<ControlLabel>Start</ControlLabel>
										<DatePicker
											selected={this.props.start && moment(this.props.start)}
											onChange={(date) => this.props.onDateChange(date, "start")}
											dateFormat="DD-MM-YYYY"
											className="form-control"
											placeholderText="Choose start day"
										/>
										{this.props.errors.start && <InlineError text={this.props.errors.start} />}
									</FormGroup>
								</Col>
								<Col md={6}>
									<FormGroup validationState={this.props.errors.end && "error"} className="datepicker-100">
										<ControlLabel>End</ControlLabel>
										<DatePicker
											selected={this.props.end && moment(this.props.end)}
											onChange={(date) => this.props.onDateChange(date, "end")}
											dateFormat="DD-MM-YYYY"
											className="form-control test"
											placeholderText="Choose end day"
										/>
										{this.props.errors.end && <InlineError text={this.props.errors.end} />}
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col md={12}>
									<FormGroup validationState={this.props.errors.type_id && "error"}>
										<ControlLabel>Type:</ControlLabel>
										<Select
											onChange={(option) => { this.props.onSelectChange(option, "type_id", "selectedType"); }}
											name="type_id"
											placeholder="Choose Day Off Type"
											value={this.props.selectedType}
											options={this.props.dayOffTypes}
											isLoading={this.props.isLoadingDayoffTypes}
											clearable={false}
											multi={false}
										/>
										{this.props.errors.type_id && <InlineError text={this.props.errors.type_id} />}
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col md={12}>
									<FormGroup validationState={this.props.errors.description && "error"}>
										<ControlLabel>Description</ControlLabel>
										<FormControl componentClass="textarea" name="description" value={this.props.formData.description || ""} onChange={this.props.onChange} />
										{this.props.errors.description && <InlineError text={this.props.errors.description} />}
									</FormGroup>
								</Col>
							</Row>
						</Modal.Body>

						<Modal.Footer>
							<Button bsStyle="primary" className="btn-min" type={"submit"} disabled={this.props.isMakingRequest}>
								{this.props.isMakingRequest ? <LoaderInline width="20" height="20" color="#fff" /> : "Request"}
							</Button>
							<Button bsStyle="default" className="btn-min" onClick={this.props.handleCloseRequestModal}>Close</Button>
						</Modal.Footer>
					</form>
				</Modal>
			</React.Fragment>
		);
	}
}

DayOffRequestModal.defaultProps = {
	selectedType: PropTypes.object,
	selectedSuperAdmin: PropTypes.object,
	errors: PropTypes.object,
	start: null,
	end: null
};

DayOffRequestModal.propTypes = {
	isMakingRequest: PropTypes.bool.isRequired,
	isLoadingDayoffTypes: PropTypes.bool.isRequired,
	showRequestModal: PropTypes.bool.isRequired,
	start: PropTypes.string,
	end: PropTypes.string,
	selectedType: PropTypes.shape({
		value: PropTypes.number,
		label: PropTypes.string
	}),
	dayOffTypes: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	formData: PropTypes.shape({
		name: PropTypes.string,
		description: PropTypes.string
	}).isRequired,
	errors: PropTypes.shape({
		description: PropTypes.string,
		name: PropTypes.string,
		start: PropTypes.string,
		end: PropTypes.string,
		superadmin_id: PropTypes.string,
		reporter_id: PropTypes.string,
		type_id: PropTypes.string,
		days_off_error: PropTypes.bool,
		days_off_allowed: PropTypes.number,
		days_off_available: PropTypes.number,
		days_off_requested: PropTypes.number,
		days_off_taken: PropTypes.number,
		message: PropTypes.string,
		period_start: PropTypes.string,
		period_end: PropTypes.string,
	}),
	onSubmit: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	onDateChange: PropTypes.func.isRequired,
	onSelectChange: PropTypes.func.isRequired,
	handleCloseRequestModal: PropTypes.func.isRequired
};

export default DayOffRequestModal;



// WEBPACK FOOTER //
// ./src/components/modals/DayOffRequestModal.js